module.exports = __webpack_public_path__ + "img/heart-fill.a828513e.svg";